// extracted by mini-css-extract-plugin
export default {"modalContainer":"H1-z","modalIndicator":"I1-z","prevBtn":"J1-z","nextBtn":"K1-z","body":"L1-z","footer":"M1-z"};